<template>
  <v-dialog
    v-model="showModal"
    max-width="600"
    persistent
  >
    <v-card
      outlined
      color="#ECEFF1"
    >
      <br>
      <h2 class="title-style">
        <v-icon
          left
          class="icon-style"
        >
          mdi-pound
        </v-icon>Create Tags
      </h2>
      <v-form ref="form">
        <v-container>
          <v-card-text class="text-body-1 text-center">
            <v-row
              class="fill-height"
            >
              <v-col
                cols="12"
                md="12"
              >
                <v-text-field
                  v-model="tagName"
                  placeholder="Tag name"
                  :rules="[(v) => !!v || 'This field is required']"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text>
            <v-chip
              v-for="item in tagsList"
              :key="item.id"
              outlined
              class="ml-2"
            >
              <span @click="deleteTag(item.id)">{{ item.name }} <v-icon>mdi-close</v-icon></span>
            </v-chip>
          </v-card-text>
          <v-card-actions>
            <v-btn
              class="mt-2"
              color="red darken-3"
              @click="showModal = false"
            >
              cancel
            </v-btn>
            <v-spacer />
            <v-btn
              class="mt-2"
              color="#FF3700"
              @click="createTag()"
            >
              create
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-form>
      <centre-spinner
        :loading="loading"
      />
      <delete-dialog
        v-if="showDelete"
        :title="'Delete Tag?'"
        @closed="showDelete = false"
        @confirmed="deleteConfirmed()"
      />
    </v-card>
  </v-dialog>
</template>
  <script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import DeleteDialog from 'src/views/dashboard/component/DeleteDialog';

  export default {
    components: {
      'centre-spinner': spinner,
      'delete-dialog': DeleteDialog,
    },
    data () {
      return {
        showModal: true,
        loading: false,
        showDelete: false,
        tagName: null,
        color: null,
        colorCodes: [{ name: 'Black', color: 'rgb(126, 24, 145)' }, { name: 'Blaze Orange', color: 'rgb(242, 107, 15)' }, { name: 'Red Pink', color: 'rgb(247, 44, 91)' }, { name: 'Cyan', color: 'rgb(0, 255, 255)' }],
      };
    },
    computed: {
      tagsList () {
        return this.$store.getters['blogs/getTags'];
      },
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    async mounted () {
      await this.fetchTags();
    },
    methods: {
      async createTag () {
        this.color = this.colorCodes[Math.floor(Math.random() * this.colorCodes.length)];
        if (this.$refs.form.validate() === true) {
          this.loading = true;
          await this.$store.dispatch('blogs/createTag', {
            name: this.tagName,
            colour: this.color.color,
            type: 'blog',
          }).then(response => {
            this.$store.dispatch('alert/onAlert', {
              message: 'Tag added successfully.',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            this.fetchTags();
            this.$emit('closed');
            this.loading = false;
            this.showModal = false;
          }).catch(() => {
            this.loading = false;
          });
        } else {
          this.$store.dispatch('alert/onAlert', {
            message: 'Fill all fields',
            type: Constants.ALERT_TYPE_ERROR,
          });
        }
      },
      async fetchTags () {
        await this.$store.dispatch('blogs/fetchTags', {
          resourceType: 'blog',
        });
      },
      deleteTag (id) {
        this.itemForDelete = id;
        this.showDelete = true;
      },
      async deleteConfirmed () {
        this.showDelete = false;
        this.loading = true;
        await this.$store.dispatch('blogs/deleteTag', {
          id: this.itemForDelete,
        });
        await this.fetchTags();
        this.loading = false;
        this.showDelete = false;
      },

    },
  };
  </script>
  <style scoped>
  .title-style {
    color: #37474F;
    margin-left: 30px;
  }
  .icon-style {
    color: #37474F;
    font-size: 45px;
  }
  </style>
